module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.collapsed) ? _c('div', {
    staticClass: "pull-right text-right col-lg-5 carousel-item-details"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_vm._v("Time:")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.item.dueDateISO, 'hh:mm A')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_vm._v("State:")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('customer-state-indicator', {
    attrs: {
      "customerStates": _vm.item.customerStates
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_vm._v("Electricity:")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_vm._v(_vm._s(_vm.item.huE) + " kWh")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_vm._v("Natural Gas:")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_vm._v(_vm._s(_vm.item.huG) + " thm")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": '/partner/customer/index/id/' + _vm.item.customerId
    }
  }, [_vm._v(_vm._s(_vm.item.title))])]), _vm._v(" "), (!_vm.collapsed) ? _c('div', {
    staticClass: "carousel-item-details"
  }, [(_vm.item.contact) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_vm._v("Contact:")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._v(_vm._s(_vm.item.contact))])]) : _vm._e(), _vm._v(" "), (_vm.item.address) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_vm._v("Address:")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._v(_vm._s(_vm.item.address))])]) : _vm._e(), _vm._v(" "), (_vm.item.note) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_vm._v("Note:")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('pre', [_vm._v(_vm._s(_vm.item.note))])])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08caa351"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taskcarousel/CarouselItem.vue
// module id = 1081
// module chunks = 0